// extracted by mini-css-extract-plugin
export default {"training-list":"training_training-list__TbOg2","header":"training_header__Laf+r","selector-container":"training_selector-container__6CcEM","footer":"training_footer__f2whf"};